/**
 * Join keys as words (turn 1 of the UX loop: "batch_ticket, csr, fill_ticket,
 * reorder_so" read like database fields). Display only; the stored key name
 * is unchanged. Common keys get the word a quality lead uses; the rest lose
 * their underscores and get a capital.
 */
const KNOWN: Record<string, string> = {
  customer_no: 'Customer',
  customer: 'Customer',
  sku: 'Product',
  item_code: 'Product',
  product: 'Product',
  lot: 'Lot',
  lots: 'Lots',
  batch: 'Batch',
  order_no: 'Order',
  sales_order: 'Order',
  po: 'PO',
  customer_po: 'Customer PO',
  invoice: 'Invoice',
  issue: 'Complaint',
  csr: 'CS rep',
  rep: 'Sales rep',
  so: 'Sales order',
};

export function keyLabel(key: string): string {
  const k = key.trim();
  const known = KNOWN[k.toLowerCase()];
  if (known) return known;
  const words = k
    .replace(/_/g, ' ')
    .replace(/\bno\b/gi, 'no.')
    .replace(/\bso\b/gi, 'SO')
    .replace(/\bpo\b/gi, 'PO')
    .trim();
  return words ? words.charAt(0).toUpperCase() + words.slice(1) : key;
}
